var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formupload"},[_c('div',{staticClass:"formtitle1"},[_vm._v("\r\n      "+_vm._s(_vm.property.name)+"\r\n      "),(_vm.property.checked)?_c('span',{staticClass:"ischeck"},[_vm._v("*")]):_vm._e(),_vm._v("\r\n       (最多"+_vm._s(_vm.property.num)+"张)\r\n    ")]),_c('div',{staticClass:"el-icon-plus upload_icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }